import { Section, CodeWrapper, NcaLink } from 'nca-acquiring-theme';
import { elasticsearchConfigSnippet, elasticsearchIndexNameSnippet } from "../../../../src/snippets/elasticsearchSnippets";
import * as React from 'react';
export default {
  Section,
  CodeWrapper,
  NcaLink,
  elasticsearchConfigSnippet,
  elasticsearchIndexNameSnippet,
  React
};